module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"escenario":"escenario","resultados":"resultados {0}","cambiar":"cambiar a {0}"}}')
  delete Component.options._Ctor
}
